module.exports = __webpack_public_path__ + "img/1_Post.d8b63515.jpg";